<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main ai_main">
        <SubTitleComponent v-if="global.type == 'client'" :title="title"></SubTitleComponent>
        <div class="box">
          <div class="tool">
            <h4>选择客户</h4>
            <div class="search">
              <el-select v-model="customerValue" placeholder="请选择" @change="customerChange">
                <el-option
                  v-for="item in customerData"
                  :key="item.number"
                  :label="item.number + item.client_name"
                  :value="item.client_name">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="part">
            <h5>选择毛坯图/手绘图</h5>
            <el-radio-group v-model="spaceCur" @change="spaceChange">
              <div class="space_box">
                <el-radio v-for="(item,index) in spaceData" :key="'space'+index" :label="item.space_type">{{ item.space_type }}</el-radio>
              </div>
            </el-radio-group>
            <div class="workblank_box" v-if="workblankData.length > 0">
              <div class="item" v-for="(item,index) in workblankData" :key="'workblank'+index">
                <img :src="item.photo_url" alt="" @click="workblankClick(index)">
                <div class="radio">
                  <el-radio v-model="workblankCur" :label="index">{{ spaceCur + (index+1) }}</el-radio>
                </div>
              </div>
            </div>
            <div class="" v-if="workblankData.length <= 0">
              <el-empty :image-size="50" description="该空间类型暂时没有上传底图!">
                <el-button type="success" @click="toWorkblank">去上传</el-button>
              </el-empty>
            </div>
          </div>
          <div class="part">
            <h5>生成模式</h5>
            <div class="generation_mode_box">
              <el-button
                :type="generationMode == 'style' ? 'success' : 'default'"
                @click="generationMode = 'style'"
                class="mode_btn">
                叠加风格图生成
              </el-button>
              <el-button
                :type="generationMode == 'prompt' ? 'success' : 'default'"
                @click="generationMode = 'prompt'"
                class="mode_btn">
                叠加提示词生成
              </el-button>
            </div>
          </div>
          <div class="part photo_box" v-if="generationMode == 'style'">
            <el-radio-group v-model="isCollapse" @change="collapseChange">
              <div class="style_type_box">
                <el-radio-button :label="'选择单张图'"></el-radio-button>
                <el-radio-button :label="'选择案例图'"></el-radio-button>
                <el-radio-button :label="'选择个人素材库'"></el-radio-button>
              </div>
            </el-radio-group>
            <div class="material_btn">
              <el-button type="success" class="" @click="materialBtnClick" plain>上传风格参考图</el-button>
            </div>
            <div class="" v-if="isCollapse == '选择单张图'">
              <el-row>
                <el-col :span="4" style="padding-right:20px">
                  <el-tag type="success" class="label" effect="light">风格</el-tag>
                </el-col>
                <el-col :span="20" class="tag_main">
                  <el-tag :type="-1 == styleNum ? 'success' : 'info'" :class="'all_item'" @click="styleClick(-1)" :effect="'light'">全部</el-tag>
                  <el-tag :type="index == styleNum ? 'success' : 'info'" v-for="(item, index) in styleData" :key="'style'+index" :effect="'light'" @click="styleClick(index)">{{ item.style_type }}</el-tag>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" style="padding-right:20px">
                  <el-tag type="success" class="label" effect="light">空间类型</el-tag>
                </el-col>
                <el-col :span="20" class="tag_main">
                  <el-tag :type="-1 == spaceNum ? 'success' : 'info'" :class="'all_item'" @click="spaceClick(-1)" :effect="'light'">全部</el-tag>
                  <el-tag :type="index == spaceNum ? 'success' : 'info'" v-for="(item, index) in spaceData" :key="'space'+index" :effect="'light'" @click="spaceClick(index)">{{ item.space_type }}</el-tag>
                </el-col>
              </el-row>
              <!-- <el-radio-group v-model="styleCur" @change="styleChange">
                <div class="style_box">
                  <el-radio v-for="(item,index) in styleData" :key="'style'+index" :label="item.style_type">{{ item.style_type }}</el-radio>
                </div>
              </el-radio-group> -->
            </div>
            <div class="" v-if="isCollapse == '选择案例图'">
              <el-row>
                <el-col :span="4" style="padding-right:20px">
                  <el-tag type="success" class="label" effect="light">公司案例</el-tag>
                </el-col>
                <el-col :span="20" class="tag_main">
                  <el-tag :type="-1 == companyCur ? 'success' : 'info'" :class="'all_item'" @click="companyClick(-1)" :effect="'light'">全部</el-tag>
                  <el-tag :type="index == companyCur ? 'success' : 'info'" v-for="(item, index) in companyData" :key="'company'+index" :effect="'light'" @click="companyClick(index)">{{ item.project_type }}</el-tag>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" style="padding-right:20px">
                  <el-tag type="success" class="label" effect="light">项目案例</el-tag>
                </el-col>
                <el-col :span="20" class="tag_main">
                  <el-tag :type="-1 == projectCur ? 'success' : 'info'" :class="'all_item'" @click="projectClick(-1)" :effect="'light'">全部</el-tag>
                  <el-tag :type="index == projectCur ? 'success' : 'info'" v-for="(item, index) in projectData" :key="'project'+index" :effect="'light'" @click="projectClick(index)">{{ item.project_type }}</el-tag>
                </el-col>
              </el-row>
            </div>
            <div class="material_box" v-if="materialData.length > 0 && isCollapse != '上传风格参考图' ">
              <waterfall height="300px" class="material_main" :col="5" :gutterWidth="20" :data="materialData" :lazyDistance="200" :loadDistance="100" @loadmore="getMaterial">
                <template>
                  <div v-for="(item, index) in materialData" :key="'meterial'+index" class="item">
                    <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="" @click="toDetail(index)">
                    <div v-if="isCollapse != '选择案例图'" class="radio" @click="materialClick(index)">
                      <el-radio v-model="materialCur" :label="index">{{ item.style_type + (index+1) }}</el-radio>
                    </div>
                    <div v-if="isCollapse == '选择案例图'" class="radio project_radio" @click="materialClick(index)">
                      <el-radio v-model="materialCur" :label="index">{{ item.project_name }}
                        <div class="project_radio_label">
                          <!-- <span v-for="itemS,indexS in item.tag">
                            <span v-if="indexS < item.tag.length - 1">{{ itemS }}&nbsp;/</span>
                            <span v-if="indexS == item.tag.length - 1">{{ itemS }}</span>
                          </span> -->
                          <span v-for="itemS,indexS in item.tag">{{ itemS }}{{ indexS < item.tag.length - 1 ? '&nbsp;/&nbsp;' : '' }}</span>
                        </div>
                      </el-radio>
                    </div>
                  </div>
                </template>
              </waterfall>
            </div>
            <div class="" v-if="materialData.length <= 0">
              <el-empty :image-size="50" description="暂无数据"></el-empty>
            </div>
            <div class="" v-if="isCollapse == '上传风格参考图'">
              <el-upload
                class="upload-demo"
                action=""
                :show-file-list="false"
                multiple
                :http-request="uploadImage">
                <img v-if="uploadImg" :src="uploadImg" class="avatar">
                <el-button v-else class="" icon="el-icon-plus"></el-button>
              </el-upload>
            </div>
          </div>
          <div class="part" v-if="generationMode == 'prompt'">
            <h5>提示词输入</h5>
            <div class="prompt_input_box">
              <div class="cue_word">
                <div class="item">
                  <el-input
                    type="textarea"
                    :rows="5"
                    placeholder="请输入内容"
                    v-model="zh_content"
                    resize="none">
                  </el-input>
                  <div class="lexicon">
                    <el-button type="success" size="small" @click="toLexicon" plain>提示词库</el-button>
                  </div>
                  <div class="translate">
                    <el-button type="success" size="small" @click="goLexicon" :loading="expandLoading" plain>AI扩写润色</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="part" v-if="generationMode == 'style'">
            <h5>AI大模型</h5>
            <div class="">
              <el-radio-group v-model="aiCur">
                <div class="ai_box">
                  <el-radio v-for="(item,index) in aiData" :key="'ai'+index" :label="item.model_id">{{ item.model_name + '(' + item.price + ')' }}</el-radio>
                </div>
              </el-radio-group>
            </div>
            <h6>提示词 <span v-if="isNanoBananaModel" class="nanobanana_warning" @click="showNanoBananaInfo">此模型极度依赖提示词！点击查看提示词技巧</span></h6>
            <div class="para_part">
              <div class="ai_para_box">
                <div class="cue_word">
                  <div class="item">
                    <el-input
                      type="textarea"
                      :rows="5"
                      placeholder="请输入提示词"
                      v-model="stylePrompt"
                      resize="none">
                    </el-input>
                    <div class="lexicon">
                      <el-button type="success" size="small" @click="toStyleLexicon" plain>提示词库</el-button>
                    </div>
                    <div class="translate">
                      <el-button type="success" size="small" @click="goStyleLexicon" :loading="styleExpandLoading" plain>AI扩写润色</el-button>
                    </div>
                  </div>
                </div>
                <!-- 风格强度和描述强度拖拽条 - 仅当选择stability开头的模型时显示 -->
                <div class="intensity_sliders" v-if="isStabilityModel">
                  <div class="slider_item">
                    <div class="slider_label">
                      <span>风格强度</span>
                      <span class="slider_value">{{ styleIntensity }}%</span>
                    </div>
                    <el-slider v-model="styleIntensity" :min="0" :max="100" :step="1"></el-slider>
                  </div>
                  <div class="slider_item">
                    <div class="slider_label">
                      <span>描述强度</span>
                      <span class="slider_value">{{ describeIntensity }}%</span>
                    </div>
                    <el-slider v-model="describeIntensity" :min="10" :max="100" :step="10"></el-slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="part" v-if="generationMode == 'prompt'">
            <h5>AI大模型</h5>
            <div class="">
              <el-radio-group v-model="aiEditCur">
                <div class="ai_box">
                  <el-radio v-for="(item,index) in aiEditData" :key="'aiedit'+index" :label="item.model_id">{{ item.model_name + '(' + item.price + ')' }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </div>
          <div class="btn_save" v-if="generationMode != ''">
            <el-button type="success" @click="onSubmit" style="width:100%;">立即生成</el-button>
            <div class="prompt">（本月剩余使用额度 {{ global.money }}元）</div>
          </div>
          <div class="effect_box" v-if="resultStatus != 0">
            <div class="complete" v-if="resultStatus == 2">
              <div class="cur">
                <img :src="effectUrl" alt="">
              </div>
              <div class="list">
                <div class="item" @click="effectClick(0)">
                  <img :src="workblankData[workblankCur].photo_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'" alt="">
                  <div class="name">底图</div>
                </div>
                <div class="item plus" v-if="generationMode == 'style'"></div>
                <div class="item" @click="effectClick(1)" v-if="generationMode == 'style'">
                  <img v-if="isCollapse != '上传风格参考图'" :src="materialData[materialCur].photo_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'" alt="">
                  <img v-if="isCollapse == '上传风格参考图'" :src="uploadImg" alt="">
                  <div class="name">参考图</div>
                </div>
                <div class="item plus" v-if="generationMode == 'prompt'"></div>
                <div class="item prompt_display" v-if="generationMode == 'prompt'">
                  <div class="prompt_text">{{ zh_content }}</div>
                  <div class="name">提示词</div>
                </div>
                <div class="item equal"></div>
                <div class="item effect" @click="effectClick(2)">
                  <img :src="effectData[0].file_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'" alt="">
                  <div class="name">效果图</div>
                </div>
              </div>
              <div class="tools">
                <div class="btn"><el-button type="success" icon="el-icon-refresh" @click="toNew">生成新的效果图</el-button></div>
                <div class="btn"><el-button type="success" icon="el-icon-video-camera" @click="toVideo">图生视频</el-button></div>
                <div class="btn"><el-button type="success" icon="el-icon-edit-outline" @click="toEdit">AI改图</el-button></div>
                <div class="btn"><el-button type="success" :icon="favoriteType == true ? 'el-icon-star-off' : 'el-icon-star-on'" @click="toFavorite">{{ favoriteType == true ? '收藏' : '取消收藏' }}</el-button></div>
                <div class="btn"><el-button type="success" icon="el-icon-download" @click="toDownload">下载</el-button></div>
              </div>
            </div>
            <div class="progress" v-if="resultStatus == 1">
              <el-progress :percentage="percent"></el-progress>
            </div>
          </div>
        </div>
        <el-dialog
          v-if="dialogVisible == 'detail'"
          :visible.sync="dialogVisit"
          top="15vh"
          :show-close="false"
          :center="true"
          :closeDetail="closeDetail">
          <div class="img" v-if="dialogCur != -1">
            <img :src="detailImg" alt="">
          </div>
        </el-dialog>
        <el-dialog
          v-if="dialogVisible == 'lexicon'"
          :visible.sync="dialogVisit"
          custom-class="lexicon_box"
          top="15vh"
          :show-close="true"
          :center="true"
          :closeDetail="closeDetail">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item v-for="(item, index) in lexiconLabelData" :key="'lexiconLabel'+index" :index="index.toString()">{{ item }}</el-menu-item>
          </el-menu>
          <div class="lexicon_list">
            <el-checkbox-group v-model="lexiconCheckList" v-if="lexiconData[activeIndex].length > 0">
              <el-checkbox v-for="(item, index) in lexiconData[activeIndex]"  :key="'lexicon'+index" :label="item.word"></el-checkbox>
            </el-checkbox-group>
            <div class="" v-if="lexiconData[activeIndex].length <= 0">
              <el-empty :image-size="50" description="暂无数据"></el-empty>
            </div>
          </div>
          <div class="choose_list" v-if="lexiconCheckList.length > 0">
            <el-tag
              v-for="(item, index) in lexiconCheckList"
              :key="'choose' + index"
              :closable="true"
              :disable-transitions="true"
              @close="handleClose(index)"
              type="success">
              {{item}}
            </el-tag>
          </div>
          <el-row :gutter="10">
            <el-col :span="4" :offset="19">
              <el-button type="success" @click="confirmLexicon">确定</el-button>
            </el-col>
          </el-row>
        </el-dialog>
        <el-dialog
          v-if="dialogVisible == 'styleLexicon'"
          :visible.sync="dialogVisit"
          custom-class="lexicon_box"
          top="15vh"
          :show-close="true"
          :center="true"
          :closeDetail="closeDetail">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item v-for="(item, index) in lexiconLabelData" :key="'styleLexiconLabel'+index" :index="index.toString()">{{ item }}</el-menu-item>
          </el-menu>
          <div class="lexicon_list">
            <el-checkbox-group v-model="lexiconCheckList" v-if="lexiconData[activeIndex].length > 0">
              <el-checkbox v-for="(item, index) in lexiconData[activeIndex]"  :key="'styleLexicon'+index" :label="item.word"></el-checkbox>
            </el-checkbox-group>
            <div class="" v-if="lexiconData[activeIndex].length <= 0">
              <el-empty :image-size="50" description="暂无数据"></el-empty>
            </div>
          </div>
          <div class="choose_list" v-if="lexiconCheckList.length > 0">
            <el-tag
              v-for="(item, index) in lexiconCheckList"
              :key="'styleChoose' + index"
              :closable="true"
              :disable-transitions="true"
              @close="handleClose(index)"
              type="success">
              {{item}}
            </el-tag>
          </div>
          <el-row :gutter="10">
            <el-col :span="4" :offset="19">
              <el-button type="success" @click="confirmStyleLexicon">确定</el-button>
            </el-col>
          </el-row>
        </el-dialog>

        <el-dialog
          v-if="dialogVisible == 'case_detail'"
          :visible.sync="dialogVisit"
          width="90%"
          custom-class="case_box"
          :show-close="true"
          :center="true"
          :closeDetail="closeCaseDetail">
          <!-- <img v-if="dialogCur != -1" :src="meterialData[dialogCur].photo_url" alt=""> -->
          <el-row :gutter="20" class="detail_box row">
            <el-col :span="14">
              <div class="img" v-if="dialogCur != -1">
                <div class="swiper-container">
                  <div style="--swiper-navigation-color: #fff; --swiper-pagination-color: #fff" class="swiper mySwiper2">
                    <div class="swiper-wrapper">
                      <div v-for="item in detailData.photo" :key="item.photo_url" class="swiper-slide">
                        <img :src="item.photo_url" />
                      </div>
                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                  </div>
                  <div thumbsSlider="" class="swiper mySwiper">
                    <div class="swiper-wrapper">
                      <div v-for="item in detailData.photo" :key="item.photo_url" class="swiper-slide">
                        <img :src="item.photo_url" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="10" v-if="dialogCur != -1">
              <div class="list">
                <div class="item title">{{ detailData.company }}</div>
                <div class="item">
                  {{ detailData.design_concept }}
                </div>
                <div class="item">
                  <div class="label">项目名称</div>
                  <div class="content">{{ detailData.project_name }}</div>
                </div>
                <div class="item">
                  <div class="label">项目地址</div>
                  <div class="content">{{ detailData.project_address }}</div>
                </div>
                <div class="item">
                  <div class="label">项目面积</div>
                  <div class="content">{{ detailData.project_area }}平方米</div>
                </div>
                <div class="item">
                  <div class="label">标签类型</div>
                  <div class="content">
                    <span v-for="value, index in detailData.tag">
                      <span v-if="index == detailData.tag.length - 1">{{ value }}</span>
                      <span v-if="index < detailData.tag.length - 1">{{ value }}&nbsp;/&nbsp;</span>
                    </span>
                  </div>
                </div>
                <div class="item">
                  <div class="label">项目类型</div>
                  <div class="content date">{{ detailData.project_type }}</div>
                </div>
                <div class="item" v-if="projectCur != -1">
                  <div class="label">设计师</div>
                  <div class="content date">{{ detailData.designer }}</div>
                </div>
                <!-- <el-button @click="toGenerate(dialogCur)" type="success">应用同款</el-button> -->
              </div>
            </el-col>
          </el-row>
          <!-- <span v-if="type == '风格' || type == '空间类型'" slot="footer" class="dialog-footer">
            <el-button @click="toGenerate(dialogCur)">生成同款</el-button>
            <el-button v-if="dialogCur >= 0" type="success" @click="toCollect(dialogCur)">{{ detailData.user_material_id == 0 ? '收藏' : '取消收藏' }}</el-button>
          </span> -->
        </el-dialog>

        <el-dialog
          :visible.sync="showNanoBananaInfoDialog"
          width="auto"
          :show-close="true"
          :center="true">
          <img src="/static/info.png" alt="提示词技巧" style="max-width: 80vw; max-height: 80vh;">
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>

import { getUser } from '../../utils/api'
import { apiDownload } from '@/utils/download';

import Swiper from 'swiper'
import 'swiper/css/swiper.css'

let _ajaxType = 0

export default {
  name: 'EffectSave',
  components: {},
  data() {
    return {
      title: '',
      id: 0,
      customerData: [],
      customerValue: '',
      spaceData: [],
      spaceCur: '',
      workblankData: [],
      workblankCur: 0,
      generationMode: '', // 生成模式：'style' 或 'prompt'
      styleData: [],
      styleCur: '',
      styleNum: -1,
      spaceNum: -1,
      companyData: [],
      companyCur: -1,
      projectData: [],
      projectCur: -2,
      materialData: [],
      materialCur: 0,
      uploadImg: '',
      aiData: [],
      aiCur: '',
      aiEditData: [],
      aiEditCur: '',
      zh_content: '',
      en_content: '',
      expandLoading: false,
      stylePrompt: '',
      styleExpandLoading: false,
      styleIntensity: 100,
      describeIntensity: 90,
      effectId: "0",
      effectData: [],
      effectDataCur: 0,
      effectUrl: '',
      resultStatus: 0,
      percent: 0,
      favoriteType: true,
      favoriteId: '',
      page: 0,
      pagesize: 20,
      allpage: 0,
      isCollapse: '选择单张图',
      aiPara: false,
      dialogVisible: '',
      dialogVisit: false,
      dialogCur: -1,
      chooseMaterial: '',
      chooseMaterialStyle: '',
      chooseMaterialSpace: '',
      lexiconData: [],
      lexiconLabelData: [],
      lexiconCheckList: [],
      activeIndex: '0',
      materialItemHeight: 100,
      materialBtnType: 0,
      detailImg: '',
      mySwiper: null,
      thumbsSwiper: null,
      showNanoBananaInfoDialog: false,
    }
  },
  computed: {
    // 判断当前选择的模型是否是 stability 开头的
    isStabilityModel() {
      return this.aiCur && this.aiCur.startsWith('stability')
    },
    // 判断当前选择的模型是否是 nanobanana 开头的
    isNanoBananaModel() {
      return this.aiCur && this.aiCur.startsWith('nanobanana')
    }
  },
  watch: {
    aiCur(newVal) {
      // 当选择 nanobanana 开头的模型时，设置默认提示词
      if(newVal && newVal.startsWith('nanobanana') && !this.stylePrompt){
        this.stylePrompt = '把图1的现场照片调整成图2的设计风格，增加装饰品细节，其余保持不变，空间透视视角不变，真实质感强，采用索尼A7R4拍摄，杂志级画质，摄影级画质。'
      }
    }
  },
  mounted() {
    let _title = '生成效果图'
    if(localStorage.getItem('material_url')){
      this.chooseMaterial = localStorage.getItem('material_url')
      let _style = localStorage.getItem('material_style')
      let _space = localStorage.getItem('material_space')
      let _type = localStorage.getItem('material_type')
      this.chooseMaterialStyle = _style
      this.styleCur = _style
      this.chooseMaterialSpace = _space
      this.spaceCur = _space
      console.log('load', this.chooseMaterial, _style, _space)
      if(_type == '公司案例' || _type == '项目案例'){
        this.isCollapse = '选择案例图'
        this.chooseCaseType = _type == '公司案例' ? 1 : 2
        this.chooseCaseId = localStorage.getItem('case_id')
      }
      localStorage.removeItem('material_type')
      localStorage.removeItem('material_url')
      localStorage.removeItem('material_style')
      localStorage.removeItem('material_space')
    }
    if(this.global.type == 'client'){
      _title = this.global.clientName
      this.getSpace()
    }
    this.title = _title
    if(this.global.type == 'manage'){
      this.getCustomer()
    }
    this.getAI()
    this.getAIEdit()
    this.getLexicon()
    this.getDeploy()
  },
  methods: {
    handleClose(cur) {
      let _lexicon = [...this.lexiconCheckList]
      _lexicon.splice(cur, 1)
      this.lexiconCheckList = _lexicon
    },
    closeDetail(e) {
      this.detailImg = ''
      this.dialogCur = -1
      this.dialogVisit = false
      this.dialogVisible = ''
      e()
    },
    closeCaseDetail(e) {
      this.detailImg = ''
      this.dialogCur = -1
      this.dialogVisit = false
      this.dialogVisible = ''
      e()
    },
    handleSelect(key, keyPath) {
      console.log('handleSelect', key, keyPath);
      this.activeIndex = key
      console.log(this.activeIndex)
    },
    handleDetal(index, row) {
      console.log(index, row);
    },
    getData() {
      //
    },
    customerChange(e) {
      console.log('customerChange', e)
      let nowCustomer = this.customerData.find(c => c.client_name === e);
      this.global.clientId = nowCustomer.client_id
      this.global.clientName = nowCustomer.client_name
      this.getSpace()
    },
    getSpace() {
      let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
      console.log('nowCustomer', nowCustomer)
      let _id = 0
      if(this.global.type == 'client'){
        _id = this.global.clientId
      }
      if(this.global.type == 'manage'){
        _id = nowCustomer.client_id
      }
      let _url = "/api/?mod=workblank_space"
      let _space_data = {
        client_id: _id
      }
      this.axios.post(_url, _space_data).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("spaceData", _data);
        if (json.data.errcode == 0) {
          this.spaceData = _data.result
          let _space = _data.result[0].space_type
          let _spaceNum = 0
          if(this.chooseMaterial != ''){
            _space = this.chooseMaterialSpace
            _spaceNum = this.spaceData.findIndex(c => c.space_type === _space)
          }
          this.spaceCur = _space
          this.spaceNum = _spaceNum
          this.getWorkblank(this.getStyle)
        }
        console.log(json.data);
      })
    },
    getWorkblank(callback) {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
      console.log('nowCustomer', nowCustomer)
      let _id = 0
      if(this.global.type == 'client'){
        _id = this.global.clientId
      }
      if(this.global.type == 'manage'){
        _id = nowCustomer.client_id
      }
      let _cur = this.spaceCur
      let _url = "/api/?mod=workblank&action=list"
      let _workblank_data = {
        client_id: _id,
        space_type: _cur
      }
      this.axios.post(_url, _workblank_data).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("spaceData", _data);
        if (json.data.errcode == 0) {
          this.workblankData = _data.result
          callback&&callback()
        }
        console.log(json.data);
      })
    },
    getDeploy() {
      let _url = "/api/?mod=deploy"
      this.axios.post(_url).then(json => {
        // 获取
        let _data = json.data.data
        console.log("deployData", _data);
        if (json.data.errcode == 0) {
          // this.styleData = _data.style
          // this.spaceData = _data.space
          this.companyData = _data.case_project_type1
          this.projectData = _data.case_project_type2
          // this.getMeterial()
        }
        // console.log(json.data);
      })
    },
    getCustomer() {
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("customerData", _data);
        if (json.data.errcode == 0) {
          let _client = _data.result[0].client_name
          if(this.global.type == 'manage' && this.global.clientName != ''){
            _client = this.global.clientName
          }
          this.customerValue = _client
          this.customerData = _data.result
          this.getSpace()
        }
        console.log(json.data);
      })
    },
    getStyle() {
      let _url = "/api/?mod=material_style"
      this.axios.post(_url).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("styleData", _data);
        if (json.data.errcode == 0) {
          let _style = _data.result[0].style_type
          if(this.chooseMaterial != ''){
            _style = this.chooseMaterialStyle
          }
          this.styleCur = _style
          this.styleData = _data.result
          this.getMaterial()
        }
        console.log(json.data);
      })
    },
    getMaterial() {
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let _style = ''
        if(this.styleNum != -1){
          _style = this.styleData[this.styleNum].style_type
        }
        let _space = ''
        if(this.spaceNum != -1){
          _space = this.spaceData[this.spaceNum].space_type
        }
        let _url = "/api/?mod=material"
        let _exclude = this.chooseMaterial
        let _material_data = {
          page: _page + 1,
          pagesize: this.pagesize,
          style_type: _style,
          space_type: _space,
          exclude: _exclude,
          type: this.materialBtnType
        }
        if(this.isCollapse == '选择案例图'){
          _url = "/api/?mod=case"
          let _caseType = 1
          let _projectType = ''
          if(this.companyCur > -1){
            _projectType = this.companyData[this.companyCur].project_type
          }
          if(this.projectCur >= -1){
            _caseType = 2
            if(this.projectCur > -1){
              _projectType = this.projectData[this.projectCur].project_type
            }
          }
          _material_data['case_type'] = _caseType
          _material_data['project_type'] = _projectType
          if(this.chooseMaterial != ''){
            _material_data['photo_url'] = this.chooseMaterial
            _material_data['case_type'] = this.chooseCaseType
            _material_data['case_id'] = this.chooseCaseId
            let _cType = -2
            let _pType = -2
            if(this.chooseCaseType == 1){
              _cType = -1
            }
            if(this.chooseCaseType == 2){
              _pType = -1
            }
            this.companyCur = _cType
            this.projectCur = _pType
          }
        }
        this.axios.post(_url, _material_data).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("materialData", _data);
          if (json.data.errcode == 0) {
            let _material = []
            if(_data.page == 1 && this.chooseMaterial != '' && this.isCollapse != '选择案例图'){
              _material.push({
                material_id: -1,
                photo_url: this.chooseMaterial,
                style_type: this.chooseMaterialStyle,
                space_type: ''
              })
            }
            console.log('material1', _material)
            let _materialArray = [..._material, ...this.materialData]
            console.log('material2', _materialArray)
            this.page = _data.page
            this.allpage = _data.allpage
            this.materialData = [..._materialArray, ..._data.result]
            if(_data.page == 1){
              this.materialItemHeight = 0
            }
          }
          console.log(json.data);
        })
      }
    },
    getAI() {
      let _url = "/api/?mod=ai_model"
      let _aiData = {
        type: 1
      }
      this.axios.post(_url, _aiData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("aiData", _data);
        if (json.data.errcode == 0) {
          this.aiCur = _data.result[0].model_id
          this.aiData = _data.result
        }
        console.log(json.data);
      })
    },
    getAIEdit() {
      let _url = "/api/?mod=ai_model"
      let _aiData = {
        type: 2
      }
      this.axios.post(_url, _aiData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("aiEditData", _data);
        if (json.data.errcode == 0) {
          this.aiEditCur = _data.result[0].model_id
          this.aiEditData = _data.result
        }
        console.log(json.data);
      })
    },
    getLexicon() {
      let _url = "/api/?mod=lexicon"
      this.axios.post(_url).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("lexiconData", _data);
        if (json.data.errcode == 0) {
          let _label = []
          let _lexicon = []
          for(let i=0;i<_data.result.length;i++){
            _label.push(_data.result[i].label)
            _lexicon.push(_data.result[i].lexicon)
          }
          this.lexiconData = _lexicon
          this.lexiconLabelData = _label
        }
        console.log(json.data);
      })
    },
    getHeight() {
      let _material = this.materialData
      if(_material.length <= 0) return
      let _materialItem = this.$refs.materialItem[0]
      console.log('height', _materialItem.offsetHeight)
      let _row = _material.length > 5 ? 2 : 1
      this.materialItemHeight = _materialItem.offsetHeight * _row + 15
    },
    spaceChange(e) {
      let _spaceType = this.spaceData.findIndex(c => c.space_type === e)
      console.log('spaceChange', _spaceType)
      this.spaceNum = _spaceType
      this.page = 0
      this.allpage = 0
      this.materialData = []
      this.getWorkblank(this.getMaterial)
    },
    styleChange(e) {
      this.page = 0
      this.allpage = 0
      this.materialData = []
      this.getMaterial()
    },
    styleClick(cur) {
      this.page = 0
      this.allpage = 0
      this.styleNum = cur
      this.materialData = []
      this.getMaterial()
    },
    spaceClick(cur) {
      this.page = 0
      this.allpage = 0
      this.spaceNum = cur
      this.materialData = []
      this.getMaterial()
    },
    companyClick(cur) {
      this.page = 0
      this.allpage = 0
      this.companyCur = cur
      this.projectCur = -2
      this.chooseMaterial = ''
      this.materialData = []
      this.getMaterial()
    },
    projectClick(cur) {
      this.page = 0
      this.allpage = 0
      this.companyCur = -2
      this.chooseMaterial = ''
      this.projectCur = cur
      this.materialData = []
      this.getMaterial()
    },
    collapseChange(e) {
      console.log(e)
      let _type = 0
      if(e == '选择个人素材库'){
        _type = 1
      }
      this.materialBtnType = _type
      this.page = 0
      this.allpage = 0
      this.styleNum = -1
      // this.spaceNum = -1
      this.companyCur = -1
      this.projectCur = -2
      this.resultStatus = 0
      this.materialData = []
      this.getMaterial()
    },
    onSubmit() {
      console.log('submit!', this.workblankCur, this.workblankData);
      let _this = this
      if(_ajaxType == 1) return

      // 验证生成模式
      if(this.generationMode == ''){
        this.$message.error('请选择生成模式！');
        return
      }

      _ajaxType = 1
      let _url = "/api/?mod=effect&action=save"
      let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue)
      console.log('nowCustomer', nowCustomer)
      let _id = 0
      if(this.global.type == 'client'){
        _id = this.global.clientId
      }
      if(this.global.type == 'manage'){
        _id = nowCustomer.client_id
      }

      // 验证毛坯图
      if(this.workblankData.length <= 0){
        _ajaxType = 0
        this.$message.error('请上传毛坯图/手绘图！');
        return
      }

      // 根据生成模式处理风格图
      let _style_img = ''
      if(this.generationMode == 'style'){
        // 叠加风格图生成模式
        if(this.isCollapse != '上传风格参考图'){
          if(this.materialData.length <= 0){
            _ajaxType = 0
            this.$message.error('请选择风格参考图！');
            return
          }
          _style_img = this.materialData[this.materialCur].photo_url
        }
        if(this.isCollapse == '上传风格参考图'){
          if(!this.uploadImg){
            _ajaxType = 0
            this.$message.error('请上传风格参考图！');
            return
          }
          _style_img = this.uploadImg
        }
      }

      // 叠加提示词生成模式 - 使用AI改图接口
      if(this.generationMode == 'prompt'){
        if(!this.zh_content || this.zh_content.trim() == ''){
          _ajaxType = 0
          this.$message.error('请输入提示词！');
          return
        }

        // 使用AI改图接口
        let _photo = this.workblankData[this.workblankCur].photo_url
        let _space = ''
        if(this.spaceCur != -1){
          _space = this.spaceCur
        }

        let _aiEditUrl = "/api/?mod=effect&action=ai_edit"
        let _aiEditData = {
          client_id: _id,
          photo_url: _photo,
          space_type: _space,
          model_id: this.aiEditCur,
          description: this.zh_content,
          workblank_id: this.workblankData[this.workblankCur].workblank_id
        }

        // 检查是否需要翻译
        let nowAiEdit = this.aiEditData.find(c => c.model_id === this.aiEditCur);
        if(nowAiEdit && nowAiEdit.language == 'en'){
          this.toTranslateForAiEdit(_aiEditData)
          return
        }

        console.log('aiEditData', _aiEditData)
        this.axios.post(_aiEditUrl, _aiEditData).then(json => {
          let _data = json.data.data
          console.log("aiEditSaveData", _data);
          if (json.data.errcode == 0) {
            this.effectId = _data.effect_id
            this.resultStatus = 1
            this.getEffect()
            this.axios.post('/api/?mod=user').then(json => {
              if(json.data.errcode == 0){
                _this.global.money = json.data.data.user.money
              }
            })
            this.$message({
              message: '提交成功，正在生成中',
              type: 'success',
              offset: 300,
              duration: 1000,
              onClose: function() {
                let scrollBox = document.querySelector('.main')
                scrollBox.scrollTo({
                  top: 10000,
                  behavior: 'smooth' // 平滑滚动
                });
              }
            });
          }
          console.log(json.data);
        })
        return
      }

      // 叠加风格图生成模式
      let _photo = this.workblankData[this.workblankCur].photo_url
      let _style = ''
      if(this.styleNum != -1){
        _style = this.styleData[this.styleNum].style_type
      }
      let _space = ''
      if(this.spaceCur != -1){
        console.log(this.spaceCur)
        // _space = this.spaceData[this.spaceCur].space_type
        _space = this.spaceCur
      }

      // 构建保存数据
      let _saveData = {
        client_id: _id,
        photo_url: _photo,
        space_type: _space,
        model_id: this.aiCur,
        style_percent: this.styleIntensity,
        description_percent: this.describeIntensity / 10
      }

      // 添加风格图相关参数
      _saveData['style_photo_url'] = _style_img
      _saveData['style_type'] = _style

      // 处理提示词
      if(this.stylePrompt && this.stylePrompt.trim() != ''){
        let _prompt = this.stylePrompt
        let nowAi = this.aiData.find(c => c.model_id === this.aiCur);
        _saveData['description'] = _prompt
        if(nowAi.language == 'en'){
          this.toTranslate(_saveData)
          return
        }
        this.axios.post(_url, _saveData).then(json => {
          // 获取
          let _data = json.data.data
          console.log("saveData", _data);
          if (json.data.errcode == 0) {
            this.effectId = _data.effect_id
            this.resultStatus = 1
            this.getEffect()
            this.axios.post('/api/?mod=user').then(json => {
              if(json.data.errcode == 0){
                _this.global.money = json.data.data.user.money
              }
            })
            this.$message({
              message: '提交成功，正在生成中',
              type: 'success',
              offset: 300,
              duration: 1000,
              onClose: function() {
                let scrollBox = document.querySelector('.main')
                scrollBox.scrollTo({
                  top: 10000,
                  behavior: 'smooth' // 平滑滚动
                });
              }
            });
          }
          console.log(json.data);
        })
        return
      }
      console.log(_saveData)
      // return
      this.axios.post(_url, _saveData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("saveData", _data);
        if (json.data.errcode == 0) {
          this.effectId = _data.effect_id
          this.resultStatus = 1
          this.getEffect()
          this.axios.post('/api/?mod=user').then(json => {
            if(json.data.errcode == 0){
              _this.global.money = json.data.data.user.money
            }
          })
          this.$message({
            message: '提交成功，正在生成中',
            type: 'success',
            offset: 300,
            duration: 1000,
            onClose: function() {
              let scrollBox = document.querySelector('.main')
              scrollBox.scrollTo({
                top: 10000,
                behavior: 'smooth' // 平滑滚动
              });
            }
          });
        }
        console.log(json.data);
      })
    },
    getEffect() {
      let _id = this.effectId
      let _url = "/api/?mod=effect&action=result"
      let _effectData = {
        effect_id: _id
      }
      this.axios.post(_url, _effectData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("effectData", _data);
        if (json.data.errcode == 0) {
          let _percent = this.percent
          if(_percent < 95){
            _percent = _percent + 5
          }
          if(_percent >= 95){
            _percent = 99
          }
          this.percent = _percent
          if(_data.status == 0){
            setTimeout(this.getEffect, 5000)
            return
          }
          if(_data.status == 1){
            _ajaxType = 0
            this.resultStatus = 2
            this.effectData = _data.result
            this.effectUrl = _data.result[0].file_url
            setTimeout(()=>{
              let scrollBox = document.querySelector('.main')
              scrollBox.scrollTo({
                top: 10000,
                behavior: 'smooth' // 平滑滚动
              });
            },300)
          }
        }
        console.log(json.data);
      })
    },
    handleChange(value) {
      console.log(value)
      console.log(this.form)
    },
    workblankClick(cur) {
      this.workblankCur = cur
    },
    toDetail(cur) {
      console.log(this.isCollapse, this.materialData, cur)
      let _type = this.isCollapse
      if(_type == '选择案例图'){
        let _url = '/api/?mod=case&action=detail'
        let _id = this.materialData[cur].case_id
        let _clientData = {
          case_id: _id
        }
        this.axios.post(_url, _clientData).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("projectDetail", _data);
          if (json.data.errcode == 0) {
            this.detailData = _data
            this.dialogVisible = 'case_detail'
            this.dialogCur = 0
            this.dialogVisit = true
            setTimeout(() => {
              // 延迟触发，需要等待页面加载完成后才能触发方法，不然无效
              let _cur = _data.photo.findIndex(c => c.photo_url === this.materialData[cur].photo_url)
              console.log(_cur)
              this.initSwiper(_cur)
            }, 200)
            // console.log(json.data);
          }
        })
        return
      }
      this.detailImg = this.materialData[cur].photo_url
      this.dialogCur = cur
      this.dialogVisit = true
      this.dialogVisible = 'detail'
    },
    toLexicon() {
      this.dialogVisit = true
      this.dialogVisible = 'lexicon'
    },
    toStyleLexicon() {
      this.dialogVisit = true
      this.dialogVisible = 'styleLexicon'
    },
    materialClick(cur) {
      this.materialCur = cur
    },
    toNew() {
      this.resultStatus = 0
      this.percent = 0
      let scrollBox = document.querySelector('.main')
      scrollBox.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动
      });
    },
    toVideo() {
      this.$router.push('/effectvideo')
    },
    toEdit() {
      this.$router.push('/effectaiedit')
    },
    toFavorite() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=effect_favorite&action=add"
      let _type = this.favoriteType
      let _id = this.effectData[this.effectDataCur].effect_result_id
      let _favoriteData = {
        effect_result_id: _id
      }
      if(_type == false){
        _url = "/api/?mod=effect_favorite&action=cancel"
        _id = this.favoriteId
        _favoriteData = {
          effect_favorite_id: _id
        }
      }
      console.log(_favoriteData)
      this.axios.post(_url, _favoriteData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("favoriteData", _data);
        if (json.data.errcode == 0) {
          this.favoriteType = !_type
          let _content = '取消成功'
          if(!_type == false){
            _content = '收藏成功'
            this.favoriteId = _data.effect_favorite_id
          }
          this.$message({
            message: _content,
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
        }
        console.log(json.data);
      })
    },
    toDownload(){
      const link = document.createElement('a')
      let _type = this.effectData[this.effectDataCur].file_type // 替换为你的图片 URL
      let _href = ''
      if(_type == 0){
        let _img = this.effectData[this.effectDataCur].file_url
        if (_img.startsWith('https://oss.ylw.s136.ailo.vip')) {
          _href = _img.replace('https://oss.ylw.s136.ailo.vip', '/ai_images');
        }
        if (_img.startsWith('https://aigc.oss.ylwai.cn')) {
          _href = _img.replace('https://aigc.oss.ylwai.cn', '/ai2_images');
        }
      }
      if(_type == 1){
        let _video = this.effectData[this.effectDataCur].file_url
        if (_video.startsWith('https://oss.ylw.s136.ailo.vip')) {
          _href = _video.replace('https://oss.ylw.s136.ailo.vip', '/ai_videos');
        }
        if (_video.startsWith('https://aigc.oss.ylwai.cn')) {
          _href = _video.replace('https://aigc.oss.ylwai.cn', '/ai2_videos');
        }
      }
      console.log('href',_href)
      apiDownload(
        _href
      )
    },
    uploadImage(image) {
      console.log("1", image);
      if(_ajaxType == 1) return
      _ajaxType = 1
      return new Promise((resolve, reject) => {
        const isImage = image.file.type.startsWith('image/');
        if (!isImage) {
          this.uploadError = '只能上传图片文件';
          _ajaxType = 0
          reject(new Error('只能上传图片文件'));
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          console.log('upload',e)
          const base64Data = e.target.result;
          this.toUpload(base64Data);
          resolve(false); // 阻止默认上传行为
        };
        reader.onerror = (error) => {
          console.error('读取文件失败:', error);
          this.uploadError = '读取文件失败，请重试';
          reject(error);
        };
        reader.readAsDataURL(image.file);
      });
    },
    toUpload(base64Data) {
      let _url = "/api/?mod=upload"
      let _uploadData = {
        photo: base64Data
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        _ajaxType = 0
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          this.uploadImg = _data.photo_url
          this.$message({
            message: '上传成功',
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
        }
        console.log(json.data);
      })
    },
    toTranslate(saveData) {
      let _url = "/api/?mod=translate"
      let _zh = this.stylePrompt
      if(!_zh || _zh.trim() == ''){
        _ajaxType = 0
        this.$message.error('请输入提示词！');
        return
      }
      let _uploadData = {
        description: _zh
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        _ajaxType = 0
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          let _url = "/api/?mod=effect&action=save"
          saveData['description'] = _data.description_en
          this.axios.post(_url, saveData).then(json => {
            let _data = json.data.data
            console.log("saveData", _data);
            if (json.data.errcode == 0) {
              this.effectId = _data.effect_id
              this.resultStatus = 1
              this.getEffect()
              // getUser().then(res => {
              //   console.log('user', res)
              //   if(res.errcode == 0){
              //     this.global.money = res.data.user.money
              //   }
              // })
              this.axios.post('/api/?mod=user').then(json => {
                if(json.data.errcode == 0){
                  _this.global.money = json.data.data.user.money
                }
              })
              this.$message({
                message: '提交成功，正在生成中',
                type: 'success',
                offset: 300,
                duration: 1000,
                onClose: function() {
                  let scrollBox = document.querySelector('.main')
                  scrollBox.scrollTo({
                    top: 10000,
                    behavior: 'smooth' // 平滑滚动
                  });
                }
              });
            }
            console.log(json.data);
          })
        }
        console.log(json.data);
      })
    },
    toTranslateForAiEdit(aiEditData) {
      let _this = this
      let _url = "/api/?mod=translate"
      let _uploadData = {
        description: aiEditData['description']
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        let _data = json.data.data
        console.log("translateData", _data);
        if (json.data.errcode == 0) {
          let _aiEditUrl = "/api/?mod=effect&action=ai_edit"
          aiEditData['description'] = _data.description_en
          this.axios.post(_aiEditUrl, aiEditData).then(json => {
            let _data = json.data.data
            console.log("aiEditSaveData", _data);
            if (json.data.errcode == 0) {
              this.effectId = _data.effect_id
              this.resultStatus = 1
              this.getEffect()
              this.axios.post('/api/?mod=user').then(json => {
                if(json.data.errcode == 0){
                  _this.global.money = json.data.data.user.money
                }
              })
              this.$message({
                message: '提交成功，正在生成中',
                type: 'success',
                offset: 300,
                duration: 1000,
                onClose: function() {
                  let scrollBox = document.querySelector('.main')
                  scrollBox.scrollTo({
                    top: 10000,
                    behavior: 'smooth' // 平滑滚动
                  });
                }
              });
            }
            console.log(json.data);
          })
        }
        console.log(json.data);
      })
    },
    effectClick(cur) {
      console.log('effectClick',cur)
      let _url = this.effectData[0].file_url
      if(cur == 0){
        _url = this.workblankData[this.workblankCur].photo_url
      }
      if(cur == 1){
        console.log('this.isCollapse', this.isCollapse)
        if(this.isCollapse == '上传风格参考图'){
          _url = this.uploadImg
        }else{
          _url = this.materialData[this.materialCur].photo_url
          console.log('materialData', this.materialData, this.materialCur);
          // materialData[materialCur].photo_url
        }
      }
      this.effectUrl = _url
    },
    confirmLexicon() {
      let _content = this.lexiconCheckList
      console.log('content', _content)
      _content = _content.join('，')
      this.zh_content = _content
      this.dialogVisible = ''
      this.dialogVisit = false
      this.lexiconCheckList = []
    },
    confirmStyleLexicon() {
      let _content = this.lexiconCheckList
      console.log('content', _content)
      _content = _content.join('，')
      this.stylePrompt = _content
      this.dialogVisible = ''
      this.dialogVisit = false
      this.lexiconCheckList = []
    },
    goLexicon() {
      console.log('goLexicon', this.zh_content)
      if(!this.zh_content || this.zh_content.trim() == ''){
        this.$message.error('请先输入提示词！');
        return
      }
      if(_ajaxType == 1) return
      _ajaxType = 1
      this.expandLoading = true
      let _url = "/api/?mod=translate&action=refine"
      let _content = this.zh_content
      let _uploadData = {
        description: _content,
        language: 'cn'
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        _ajaxType = 0
        this.expandLoading = false
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          this.zh_content = _data.description.replace('\n\n', '')
        }
        console.log(json.data);
      }).catch(error => {
        _ajaxType = 0
        this.expandLoading = false
        console.error('AI扩写失败:', error);
      })
    },
    goStyleLexicon() {
      console.log('goStyleLexicon', this.stylePrompt)
      if(!this.stylePrompt || this.stylePrompt.trim() == ''){
        this.$message.error('请先输入提示词！');
        return
      }
      if(_ajaxType == 1) return
      _ajaxType = 1
      this.styleExpandLoading = true
      let _url = "/api/?mod=translate&action=refine"
      let _content = this.stylePrompt
      let _uploadData = {
        description: _content,
        language: 'cn'
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        _ajaxType = 0
        this.styleExpandLoading = false
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          this.stylePrompt = _data.description.replace('\n\n', '')
        }
        console.log(json.data);
      }).catch(error => {
        _ajaxType = 0
        this.styleExpandLoading = false
        console.error('AI扩写失败:', error);
      })
    },
    toWorkblank() {
      this.$router.push('/workblank')
    },
    materialBtnClick() {
      // let _type = 0
      // if(this.materialBtnType == 0){
      //   _type = 1
      // }
      // this.materialBtnType = _type
      // this.page = 0
      // this.allpage = 0
      // this.materialData = []
      // this.getMaterial()
      this.isCollapse = '上传风格参考图'
    },
    initSwiper(cur) {
      let _this = this
      console.log('initSwiper-------------')
      this.mySwiper = new Swiper(".mySwiper", {
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        initialSlide: cur,
      });
      this.thumbsSwiper = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        initialSlide: cur,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: this.mySwiper,
        },
        on: {
          slideChange: function() {
            console.log(this.activeIndex)
            let _index = this.activeIndex
            let _photo = _this.detailData.photo[_index].photo_url
            let _cur = _this.dialogCur
            _this.materialData[_cur].photo_url = _photo
          },
        },
      });
    },
    showNanoBananaInfo() {
      this.showNanoBananaInfoDialog = true
    },
  }
}
</script>

<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #f8f8f8;
    box-sizing: border-box;
    .tool {
      position: relative;
      background: #fff;
      padding: 10px 20px 10px 120px;
      h4 {
        position: absolute;
        top: 10px;
        left: 20px;
        color: rgb(16, 16, 16);
        font-size: 20px;
        font-weight: 400;
        line-height: 2em;
      }
    }
    .part {
      position: relative;
      background: #fff;
      margin-top: 28px;
      padding: 10px 20px 20px;
      box-sizing: border-box;
      border-radius: 4px;
      h5 {
        height: 50px;
        font-size: 20px;
        font-weight: normal;
        line-height: 50px;
      }
    }
    h6 {
      margin-bottom: 20px;
      padding-left: 24px;
      background: url(../../assets/ico_model.png) no-repeat;
      background-position: 0 center;
      background-size: auto 20px;
      font-size: 18px;
      font-weight: normal;
      .nanobanana_warning {
        margin-left: 10px;
        color: #f56c6c;
        font-size: 14px;
        font-weight: normal;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
          color: #e64545;
        }
      }
    }
    .para_part {
      padding-left: 24px;
    }
    .generation_mode_box {
      display: flex;
      gap: 20px;
      margin-top: 10px;
      .mode_btn {
        flex: 1;
        height: 48px;
        font-size: 16px;
      }
    }
    .prompt_input_box {
      margin-top: 10px;
      .cue_word {
        .item {
          position: relative;
          .lexicon {
            position: absolute;
            right: 0;
            bottom: 0;
          }
          .translate {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
    .el-input__inner {
      width: auto;
    }
    .form {
      margin-top: 20px;
    }
    .space_box {
      margin-top: 10px;
    }
    .space_box,
    .style_box,
    .ai_box {
      font-size: 0;
      .el-radio {
        margin: 0 30px 20px 0;
      }
    }
    .style_type_box {
      margin: 10px 0 30px;
    }
    .ai_para_box {
      .cue_word {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 10px;
        margin-bottom: 10px;
      }
      .item {
        position: relative;
        .lexicon {
          position: absolute;
          right: 0;
          bottom: 0;
        }
        .translate {
          position: absolute;
          top: 0;
          left: 0;
        }
        .ai_translate {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
      .slider {
        //
      }
      .intensity_sliders {
        margin-top: 20px;
        padding: 15px;
        background: #f5f7fa;
        border-radius: 8px;
        .slider_item {
          margin-bottom: 15px;
          &:last-child {
            margin-bottom: 0;
          }
          .slider_label {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            font-size: 14px;
            color: #333;
            .slider_value {
              color: #50b85c;
              font-weight: 500;
            }
          }
        }
      }
    }
    .upload-demo {
      width: 200px;
      margin-top: 20px;
      .el-button {
        width: 100%;
        aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
      }
      img {
        width: 100%;
        aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
        object-fit: cover;
      }
    }
    .workblank_box {
      display: grid;
      grid-template-columns: repeat(9, 1fr);
      padding-inline-start: 0;
      gap: 10px;
      .item {
        position: relative;
        background: #fff;
        box-sizing: border-box;
        img {
          width: 100%;
          aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          object-fit: cover;
        }
        .radio {
          margin-top: 8px;
          padding-right: 10%;
          box-sizing: border-box;
          font-size: 0;
          text-align: center;
        }
      }
    }
    .material_btn {
      position: absolute;
      top: 20px;
      right: 20px;
    }
    .material_type {
      margin-top: 30px;
    }
    .photo_box {
      .tag_main {
        position: relative;
        // padding-left: 90px;
        vertical-align: top;
        font-size: 0;
        .all_item {
          // position: absolute;
          // top: 0;
          // left: 0;
          // background: transparent;
          border: 0;
        }
        .tag_box {
          display: inline-block;
        }
      }
      .el-tag {
        margin: 0 16px 16px 0;
        // padding: 0 20px;
        // border: 0;
        height: 30px;
        // color: rgba(10,10,10,1);
        font-size: 18px;
        line-height: 30px;
        border: 0;
        &.el-tag--info {
          background: transparent;
        }
        &.label {
          width: 100%;
          text-align: center;
          // font-size: 24px;
          // font-weight: 700;
        }
        &.on {
          // font-size: 24px;
          // font-weight: 700;
        }
      }
    }
    .material_box {
      min-height: 100px;
      max-height: 300px;
      overflow: auto;
      .material_main {
        .item {
          position: relative;
          margin-bottom: 20px; /* 底部间距 */
          background: #fff;
          box-sizing: border-box;
          img {
            width: 100%;
          }
          .radio {
            margin-top: 8px;
            padding-right: 10%;
            box-sizing: border-box;
            font-size: 0;
            text-align: center;
            .project_radio_label {
              margin-top: 10px;
            }
            // &.project_radio {
            //   text-align: left;
            // }
          }
        }
      }
    }
    .btn_save {
      width: 30vw;
      margin-top: 30px;
      .prompt {
        margin-top: 10px;
        width: 100%;
        color: #999;
        text-align: center;
      }
    }
    .effect_box {
      margin-top: 30px;
      padding: 20px;
      background: #fff;
      box-sizing: border-box;
      border-radius: 4px;
      .complete {
        .cur {
          height: 400px;
          text-align: center;
          img {
            max-width: 100%;
            height: 100%;
          }
        }
        .list {
          margin-top: 10px;
          display: grid;
          grid-template-columns: repeat(9, 1fr);
          padding-inline-start: 0;
          gap: 10px;
          .item {
            padding: 10px;
            background: #fff;
            border-radius: 5px;
            box-sizing: border-box;
            img {
              width: 100%;
              aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
              object-fit: cover;
            }
            .name {
              font-size: 18px;
              text-align: center;
              line-height: 30px;
            }
            &:nth-child(1) {
              grid-column: 3;
            }
            &:nth-child(odd) {
              width: 200px;
            }
            &.plus {
              margin-bottom: 30px;
              background: url(../../assets/ico_plus.png) no-repeat;
              background-size: 100% auto;
              background-position: center center;
            }
            &.equal {
              margin-bottom: 30px;
              background: url(../../assets/ico_equal.png) no-repeat;
              background-size: 100% auto;
              background-position: center center;
            }
            &.effect img {
              border: 4px solid #50b85c;
              box-sizing: border-box;
            }
            &.prompt_display {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              padding: 20px;
              background: #f5f5f5;
              .prompt_text {
                width: 100%;
                max-height: 120px;
                overflow-y: auto;
                font-size: 14px;
                line-height: 1.6;
                color: #333;
                text-align: left;
                word-break: break-word;
              }
            }
          }
        }
        .tools {
          margin-top: 10px;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          padding-inline-start: 0;
          gap: 10px;
          .el-button {
            width: 100%;
          }
        }
      }
      .progress {
        padding: 150px 0;
      }
    }
  }
  .lexicon_list {
    width: 60vw;
    min-height: 200px;
    margin-top: 20px;
    font-size: 0;
    .el-checkbox {
      margin: 0 30px 20px 0;
    }
  }
  .choose_list {
    margin-top: 30px;
    font-size: 0;
    .label {
      font-size: 14px;
      line-height: 30px;
    }
    .el-tag {
      margin: 0 0 10px 10px;
    }
    .el-button {
      margin: 0 0 10px 10px;
    }
  }
  .detail_box {
    display: flex;
    // flex-direction: column;
    .img {
      font-size: 0;
      img {
        max-width: 100%;
        max-height: 50vh;
        border-radius: 10px;
      }
      video {
        max-width: 100%;
        max-height: 50vh;
      }
    }
    .list {
      display: grid;
      grid-template-rows: 50px;       /* 首行高度80px */
      // grid-auto-rows: minmax(60px, 1fr);
      // grid-auto-rows: minmax(calc(100%/7), 1fr);
      gap: 10px;
      height: 100%;
      padding: 20px;
      align-items: center;
      box-sizing: border-box;
      border: 1px solid #eee;
      border-radius: 10px;
      .item {
        height: 100%;
        border-bottom: 1px solid #eee;
        .label {
          display: flex;
          width: 35%;
          height: 100%;
          float: left;
          font-size: 18px;
          line-height: 26px;
          align-items: center;
          span {
            display: inline-block;
          }
        }
        .content {
          display: flex;
          width: 65%;
          height: 100%;
          float: right;
          font-size: 18px;
          line-height: 26px;
          justify-items: right;
          align-items: center;
          &.date {
            font-size: 16px;
          }
        }
        &.title {
          height: auto;
          font-size: 24px;
          font-weight: 700;
        }
        &:last-child {
          border: 0;
        }
      }
    }
  }
  .case_box {
    display: block;
  }
}
.el-dialog {
  .img {
    font-size: 0;
    text-align: center;
    img {
      max-width: 80vw;
      max-height: 70vh;
      object-fit: contain;
    }
  }
}
.el-divider--horizontal {
  margin: 30px 0;
}
.el-divider__text {
  font-size: 20px;
  font-weight: normal;
}
.subtitle_small .el-divider__text {
  font-size: 18px;
}
.el-radio-button:first-child .el-radio-button__inner {
  border-radius: 0;
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.mySwiper2 {
  height: 80%;
  width: 100%;
}

.mySwiper {
  width: 80%;
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
}

.mySwiper .swiper-slide {
  width: 20%;
  height: 100%;
  opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-button-prev,
.swiper-button-next {
  top: auto;
  bottom: 10px;
  color: #000;
}

.swiper-container-thumbs img {
  width: 100%;
  height: 50px;
  aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
  object-fit: cover !important;
}

.material_box .el-radio {
  width: 100%;
  white-space: inherit;
}
</style>



// WEBPACK FOOTER //
// src/views/Effect/Save.vue